import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';
import { v4 as uuidv4 } from 'uuid';
import { connect, useDispatch } from 'react-redux';
import { Dispatch, useCallback, useEffect, useMemo, useState } from 'react';
import { useField } from 'react-final-form';

import { ShowMoreButton } from 'UIPackage/MainModule/components/ShowMoreButton/ShowMoreButton';
import { IKnmErknmFormObject } from 'KnmErknmPackage/MainModule/interfaces/IKnmErknmFormObject';
import { OBJECTS_BLOCK_ID } from 'KnmErknmPackage/MainModule/constants/knmErknmFieldsElementsIds';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import {
  getKnmDataCreated,
  getKnmErknmDangerClassesSelectOptions,
  getKnmErknmReasonsFormValue,
  getKnmErknmRiskCategoriesSelectOptions,
  getKnmErknmSubjectKindsSelectOptions,
  getKnmErknmSubjectSubKindsSelectOptions,
  getKnmErknmSubjectTypesSelectOptions,
  getKnmFormRef,
  getKnmIsCanRefreshControlObject,
  getKnmIsChangeSubjectTypeFromActionsAvailable,
  getKnmKnoSupervisionUuid,
  getKnmOrderVersionId,
  getKnmTypeFormValue,
  getTargetEntitySelectOptions,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { Button } from 'UIPackage/MainModule/components/Button';
import { KNM_OBJECTS_INFO } from 'CorePackage/MainModule/routes/routes';
import { ErknmFillInProcessMessage } from 'KnmErknmPackage/MainModule/components/ErknmFillInProcessMessage';
import { SelectPrescriptionNotice } from 'KnmErknmPackage/MainModule/components/SelectPrescriptionNotice';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IDangerClass248 } from 'APIPackage/DictionariesModule/interfaces/IDangerClass248';
import { IRiskCategory248 } from 'APIPackage/DictionariesModule/interfaces/IRiskCategory248';
import { ISubjectKind } from 'APIPackage/DictionariesModule/interfaces/ISubjectKind';
import { ISubjectType } from 'APIPackage/DictionariesModule/interfaces/ISubjectType';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { Tooltip } from 'UIPackage/MainModule/components/Tooltip';
import { ErknmApproveRemarkSectionCodeEnum } from 'KnmErknmPackage/ErknmApproveRemarkModule/enums/ErknmApproveRemarkSectionCodeEnum';
import { useHasFieldApproveRemark } from 'KnmErknmPackage/MainModule/common/useHasFieldApproveRemark';
import { getIsPlanErknmStatusConsidered } from 'APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { getPlanListPlanErknmStatus } from 'PlanListPackage/MainModule/selectors/planListSelectors';
import { createTypedUseFormError } from 'hooks/useTypedFormField';
import { findRegionSelectOption } from 'KnmPackage/MainModule/components/regions';
import { IDictionarySubjectTypeSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySubjectTypeSelectOption';
import { KnmReasonTypeNameEnum } from 'KnmPackage/MainModule/enums/KnmReasonTypeNameEnum';

import { KnmObjectItem } from '../../../KnmPackage/KnmObjectsModule/components/KnmObjectItem';
import { KnmErvkObjectsModal } from '../../../KnmPackage/KnmObjectsModule/components/KnmErvkObjectsModal';
import { IErvkObjectsOfControl } from '../../../APIPackage/KnmModule/interfaces/IErvkObjectsOfControl';
import { KnmKindCodesEnum } from '../../../APIPackage/DictionariesModule/enums/KnmKindCodesEnum';
import { IKnmErknmFormSubject } from '../../MainModule/interfaces/IKnmErknmFormSubject';
import { ITargetEntity } from '../../../APIPackage/DictionariesModule/interfaces/ITargetEntity';
import { RootActions } from '../../../CorePackage/MainModule/types/RootActions';
import { INotification } from '../../../CorePackage/NotificationModule/interfaces/INotification';
import { addNoticeAction } from '../../../CorePackage/NotificationModule/actions/NoticeActions';
import { NoticeTypesEnum } from '../../../CorePackage/NotificationModule/enums/NoticeTypesEnum';
import { MessageTypesEnum } from '../../../CorePackage/NotificationModule/enums/MessageTypesEnum';
import { IErvkObjectsOfControlSubjectData } from '../../../APIPackage/KnmModule/interfaces/IErvkObjectsOfControlSubjectData';
import { KnmSubjectTypesEnum } from '../../ErknmSubjectModule/components/ErknmSubjectInfo';
import {
  dictionariesErvkCheckListGet,
  dictionariesSubjectKindsItemGet,
  dictionariesSubjectSubKindsItemGet,
} from '../../../CorePackage/DictionariesModule/actions/dictionariesActions';
import { IKnmErknmForm } from '../../MainModule/interfaces/IKnmErknmForm';
import { getKnoSupervisionHazardClassApplies } from '../../../CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IKnmTypeSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmTypeSelectOption';
import { KnmTypeCodesEnum } from '../../../APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { mapSubjectTypeCodeToName } from '../../../KnmPackage/KnmObjectsModule/common/mapSubjectTypeCodeToName';
import { addObject } from '../../../KnmPackage/KnmObjectsModule/common/addObject';
import { addErvkObject } from '../../../KnmPackage/KnmObjectsModule/common/addErvkObject';
import { getObjectBlockId } from '../../../KnmPackage/MainModule/constants/fieldsElementsIds';
import {
  getCountriesSelectOptions,
  getDistrictSelectOptions,
} from '../../../CorePackage/CatalogsModule/selectors/catalogsSelectors';
import { ICountrySelectOption } from '../../../CorePackage/CatalogsModule/interfaces/ICountrySelectOption';
import { ErknmFieldMark } from '../../MainModule/components/ErknmFieldMark';
import { ErknmApproveRemarkAddButton } from '../../ErknmApproveRemarkModule/components/ErknmApproveRemarkAddButton';
import { ErknmApproveRemark } from '../../ErknmApproveRemarkModule/components/ErknmApproveRemark';
import { IKnmDistrictSelectOption } from '../../../CorePackage/CatalogsModule/interfaces/IKnmDistrictSelectOption';
import { useShowMore } from '../../../hooks/useShowMore';
import { Spinner } from '../../../UIPackage/MainModule/components/Spinner';
import styles from '../../ErknmPlanHistoryModule/components/ErknmPlanHistory.module.scss';
import { getKnmErknmIsPrescriptionOldRules } from '../../MainModule/selectors/knmErknmSelectors';

interface IErknmObjectsProps {
  isWatchOnly: boolean;
  kindKnmCode: string | undefined;
  addOnlyProductionObject?: undefined | boolean;
  invalidFields: string[] | undefined;
}

interface IErknmObjectsStoreProps {
  created: string | null | undefined;
  countriesSelectOptions: ICountrySelectOption[] | undefined;
  dangerClassesSelectOptions: IDictionarySelectOption<IDangerClass248>[] | undefined;
  formRef: IKnmFormRef | undefined;
  hazardClassApplies: boolean | undefined;
  knmType: IKnmTypeSelectOption | undefined;
  objectKindsSelectOptions: IDictionarySelectOption<ISubjectKind>[] | undefined;
  objectSubKindsSelectOptions: IDictionarySelectOption<ISubjectKind>[] | undefined;
  objectTypesSelectOptions: IDictionarySelectOption<ISubjectType>[] | undefined;
  riskCategoriesSelectOptions: IDictionarySelectOption<IRiskCategory248>[] | undefined;
  subjectTypeOptions: IDictionarySelectOption<ITargetEntity>[] | undefined;
  isCanRefreshControlObject?: boolean | undefined;
  settings: IAdminSetting[] | undefined;
  isChangeSubjectTypeFromActionsAvailable: boolean;
  knmPlanStatus: ErknmPlanStatusesEnum | undefined;
  districtSelectOptions: IKnmDistrictSelectOption[] | undefined;
  knoSupervisionUuid?: string;
  orderVersionId?: string;
  reasonUuid?: string;
  isPassportByCheckPrescriptionOldRules?: boolean | undefined;
}

const useError = createTypedUseFormError<IKnmErknmForm>();

const ErknmObjectsWithoutStore = ({
  isWatchOnly,
  isCanRefreshControlObject,
  kindKnmCode,
  created,
  countriesSelectOptions,
  dangerClassesSelectOptions,
  formRef,
  hazardClassApplies,
  knmType,
  objectKindsSelectOptions,
  objectSubKindsSelectOptions,
  objectTypesSelectOptions,
  riskCategoriesSelectOptions,
  subjectTypeOptions,
  addOnlyProductionObject,
  settings,
  knmPlanStatus,
  districtSelectOptions,
  invalidFields,
  isChangeSubjectTypeFromActionsAvailable,
  knoSupervisionUuid,
  orderVersionId,
  reasonUuid,
  isPassportByCheckPrescriptionOldRules,
}: IErknmObjectsProps & IErknmObjectsStoreProps) => {
  const push = formRef?.current.mutators.push;
  const remove = formRef?.current.mutators.remove;
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const isObjectDeleted = useField<boolean>('isObjectDeleted').input.value ?? false;

  const isPlanned = knmType?.value === KnmTypeCodesEnum.PP;
  const isKnmPlanStatusConsidered = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isKnmKindRemarkExist = useHasFieldApproveRemark(ErknmApproveRemarkSectionCodeEnum.KIND_KNM);

  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);

  const { error: fieldError } = useError('objectsErknm');
  const toDisplayFieldError = typeof fieldError === 'string' ? fieldError : undefined;

  const openModal = () => {
    setIsModalVisible(true);
  };
  const closeModal = () => {
    setIsModalVisible(false);
  };

  const addNotice: (notice: INotification) => void = useCallback(
    (notice: INotification) => dispatch(addNoticeAction(notice)),
    [dispatch],
  );

  const isUseOnlyLowRiskInManualObject = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.KNM_VALIDATION_223_4_1_42_STARTS_FROM,
  );

  /**
   * Элемент "низкий риск"
   */
  const lowRisk = useMemo(() => {
    return riskCategoriesSelectOptions?.find(risk => risk.code === '6');
  }, [riskCategoriesSelectOptions]);

  /**
   * Переменная, отвечающая за блокировку кнопки "Добавить вручную"
   */
  const isDisabledButtonAddManual = useMemo(() => {
    return isWatchOnly || (isUseOnlyLowRiskInManualObject && !lowRisk);
  }, [isWatchOnly, isUseOnlyLowRiskInManualObject, lowRisk]);

  const addKnmObject = useCallback(() => {
    addObject(isWatchOnly, push, 'objectsErknm', isUseOnlyLowRiskInManualObject && lowRisk ? lowRisk : undefined);
  }, [push, isWatchOnly, isUseOnlyLowRiskInManualObject, lowRisk]);

  const addFromErvk = useCallback(
    async (ervkObjects: IErvkObjectsOfControl[], subjects: IErvkObjectsOfControlSubjectData[]) => {
      if (!isWatchOnly && push) {
        if (addOnlyProductionObject && ervkObjects?.findIndex(object => object.objectType.code !== '3') > -1) {
          addNotice({
            renderContent: <>Допустимо добавление только производственного объекта</>,
            noticeType: NoticeTypesEnum.ERROR,
            messageType: MessageTypesEnum.DELETE_REQUIREMENT,
            id: uuidv4(),
          });
        } else {
          let id;

          if (subjects.length) {
            // Ждём push объектов на форму, иначе onChangeObjectKindChange уйдёт с пустым subjectKindIds
            await Promise.all(
              subjects.map(async subject => {
                const subjectTypeCode = mapSubjectTypeCodeToName(subject.subjectType);
                const isFIZ = subjectTypeCode === KnmSubjectTypesEnum.FIZ;
                const isIFIZ = subjectTypeCode === KnmSubjectTypesEnum.IFIZ;
                const isIP = subjectTypeCode === KnmSubjectTypesEnum.IP;
                const isSubjectAddressInFias = subject.locationIsFromFias;
                // regionCode это регион осуществления контроля, а не местоположения субъекта, поэтому в поиск не берем
                const searchLocationFiasRegionId = subject.locationRegionFiasUuid || subject.locationRegionCode;
                const locationFiasRegion = await findRegionSelectOption(
                  subject.address,
                  searchLocationFiasRegionId,
                  districtSelectOptions,
                );
                const relatedObjects = ervkObjects.filter(x => x.subjects.filter(s => s.inn === subject.inn)?.length);
                const firstObject = relatedObjects[0];
                const objectAddress =
                  firstObject?.address && firstObject.address.trim().length > 0 ? firstObject.address : undefined;
                const searchId = subject.locationRegionFiasUuid || subject.locationRegionCode;
                const foundRegion = await findRegionSelectOption(
                  firstObject?.address,
                  searchId || undefined,
                  districtSelectOptions,
                );

                const subjectAddressWithFallback = subject?.address ? subject?.address : objectAddress;

                const addingSubjectItem: IKnmErknmFormSubject = {
                  inn: subject?.inn,
                  ogrn: subject?.ogrn,
                  position: undefined,
                  okveds: undefined,
                  addressFns: undefined,
                  locationnotInFIAS: !isSubjectAddressInFias,
                  organizationName:
                    isFIZ || isIFIZ || isIP
                      ? `${subject.surName} ${subject.firstName} ${subject.middleName}`
                      : subject?.organizationFullName,
                  firstOrganizationName: undefined,
                  mspCode: undefined,
                  mspRegistryDate: undefined,
                  locationmanualAddress: isSubjectAddressInFias ? undefined : subject?.address,
                  checkSubjectResult: null,
                  dateCreate: undefined,
                  isAutocomplete: undefined,
                  isFiz: undefined,
                  guid: undefined,
                  isDocumentOrganization: false,
                  listId: uuidv4(),
                  isNew: true,
                  nkoForeignAgentsRegistryNumber: undefined,
                  nkoForeignAgentsRegistryInclusionDate: undefined,
                  nkoForeignAgentsRegistryExclusionDate: undefined,
                  isNko: undefined,
                  subjectType: subjectTypeOptions?.find(x => x.label === subjectTypeCode),
                  kpp: subject?.kpp,
                  smevRequestStatus: undefined,
                  rafpNza: subject?.rafp,
                  isForeignSubjectAgencyNotRegistredInRf: undefined,
                  country: subject?.nationality
                    ? countriesSelectOptions?.find(c => c.title === subject.nationality)
                    : undefined,
                  isSonko: undefined,
                  locationAddress: !isIP ? subjectAddressWithFallback : undefined,
                  workAddress: undefined,
                  factualAddress: isIP ? subjectAddressWithFallback : undefined,
                  snils: subject?.snils,
                  document: subject.identityDocumentNumber,
                  epguNotifications: undefined,
                  isPresentInItRegistry: undefined,
                  itAccreditationResponse: undefined,
                  smevItAccreditationRequestStatus: undefined,
                  ervkId: subject?.id,
                  inspectionResults: undefined,
                  locationfiasRegion: locationFiasRegion ?? foundRegion,
                  locationregion: locationFiasRegion ?? foundRegion,
                };

                const organizations = formRef?.current.getFieldState('organizations')?.value;

                if (organizations && organizations.length > 0) {
                  if (!organizations.find(x => x.inn === addingSubjectItem.inn)) {
                    if (kindKnmCode === KnmKindCodesEnum.RO) {
                      push('organizations', addingSubjectItem);
                      const objects = formRef?.current.getFieldState('objectsErknm')?.value;

                      await Promise.all(
                        ervkObjects
                          .filter(x => x.subjects.filter(s => s.inn === addingSubjectItem.inn)?.length)
                          .map(async object => {
                            const existedObject = objects?.find(obj => obj.ervkId === object.ervkId);

                            if (existedObject && addingSubjectItem.ervkId) {
                              existedObject.organizationErvkId?.push(addingSubjectItem.ervkId);
                              formRef.current.change(
                                // @ts-ignore
                                `objectsErknm[${objects?.indexOf(existedObject)}].organizationErvkId`,
                                existedObject.organizationErvkId,
                              );
                            } else {
                              await addErvkObject(
                                object,
                                addingSubjectItem.ervkId,
                                dangerClassesSelectOptions,
                                objectKindsSelectOptions,
                                objectSubKindsSelectOptions,
                                objectTypesSelectOptions,
                                riskCategoriesSelectOptions,
                                districtSelectOptions,
                                push,
                                'objectsErknm',
                              );
                            }
                          }),
                      );
                    } else {
                      id = uuidv4();
                    }
                  } else {
                    await Promise.all(
                      ervkObjects
                        .filter(x => x.subjects.filter(s => s.inn === addingSubjectItem.inn)?.length)
                        .map(object =>
                          addErvkObject(
                            object,
                            addingSubjectItem.ervkId,
                            dangerClassesSelectOptions,
                            objectKindsSelectOptions,
                            objectSubKindsSelectOptions,
                            objectTypesSelectOptions,
                            riskCategoriesSelectOptions,
                            districtSelectOptions,
                            push,
                            'objectsErknm',
                          ),
                        ),
                    );
                  }
                } else {
                  push('organizations', addingSubjectItem);
                  await Promise.all(
                    ervkObjects
                      .filter(x => x.subjects.filter(s => s.inn === addingSubjectItem.inn)?.length)
                      .map(object =>
                        addErvkObject(
                          object,
                          addingSubjectItem.ervkId,
                          dangerClassesSelectOptions,
                          objectKindsSelectOptions,
                          objectSubKindsSelectOptions,
                          objectTypesSelectOptions,
                          riskCategoriesSelectOptions,
                          districtSelectOptions,
                          push,
                          'objectsErknm',
                        ),
                      ),
                  );
                }
              }),
            );
          } else {
            await Promise.all(
              ervkObjects.map(object =>
                addErvkObject(
                  object,
                  undefined,
                  dangerClassesSelectOptions,
                  objectKindsSelectOptions,
                  objectSubKindsSelectOptions,
                  objectTypesSelectOptions,
                  riskCategoriesSelectOptions,
                  districtSelectOptions,
                  push,
                  'objectsErknm',
                ),
              ),
            );
          }

          if (id) {
            addNotice({
              renderContent: <>В паспорт можно добавить сведения только об одном контролируемом лице</>,
              noticeType: NoticeTypesEnum.ERROR,
              messageType: MessageTypesEnum.DELETE_REQUIREMENT,
              id,
            });
          } else {
            closeModal();
            onChangeObjectKindChange();
          }
        }
      }
    },
    [
      push,
      isWatchOnly,
      objectTypesSelectOptions,
      objectKindsSelectOptions,
      objectSubKindsSelectOptions,
      riskCategoriesSelectOptions,
      dangerClassesSelectOptions,
      districtSelectOptions,
      addOnlyProductionObject,
      addNotice,
      kindKnmCode,
      subjectTypeOptions,
      countriesSelectOptions,
      formRef,
    ],
  );

  const reasonsErknm = formRef?.current.getFieldState('reasonsErknm')?.value;

  const makeRemoveKnmObjectHandler = (index: number, organizationErvkIds: string[] | null | undefined) => () => {
    if (organizationErvkIds) {
      organizationErvkIds.forEach(orgErvkId => {
        if (
          formRef?.current
            .getFieldState('objectsErknm')
            ?.value?.filter(obj => obj.organizationErvkId?.includes(orgErvkId))?.length === 1
        ) {
          const organizations = formRef?.current.getFieldState('organizations')?.value;
          const removableOrganization = organizations?.find(org => org.ervkId === orgErvkId);

          if (organizations && removableOrganization) {
            !isWatchOnly &&
              remove &&
              remove('organizations', organizations.indexOf(removableOrganization)) &&
              formRef?.current?.change('isSubjectDeleted', true);
          }
        }
      });
    }

    !isWatchOnly && remove && remove('objectsErknm', index) && formRef?.current?.change('isObjectDeleted', true);
  };

  /**
   * Обработчик изменения какого либо вида объекта
   */
  const onChangeObjectKindChange = useCallback(() => {
    const kindKnm = formRef?.current.getFieldState('kindKnm')?.value;
    const kindControl = formRef?.current.getFieldState('kindControl')?.value;
    const objectsErknm = formRef?.current.getFieldState('objectsErknm')?.value;
    const checklistsErknm = formRef?.current.getFieldState('checklistsErknm')?.value;

    const subjectKindIds: string[] = [];

    objectsErknm?.forEach(item => {
      if (item.objectKind && subjectKindIds?.indexOf(item.objectKind?.value.dictVersionId) === -1) {
        subjectKindIds?.push(item.objectKind?.value.dictVersionId);
      }
    });

    if (kindKnm && kindControl) {
      dispatch(
        dictionariesErvkCheckListGet({
          controlKindId: kindControl?.value.dictVersionId,
          knmKindId: kindKnm?.value.dictVersionId,
          subjectKindIds,
        }),
      );
    }

    if (checklistsErknm) {
      checklistsErknm.forEach((item, i) => {
        formRef?.current.change(`checklistsErknm.${i}.ervkCheckList` as keyof IKnmErknmForm);
      });
    }
  }, [formRef, dispatch]);

  /**
   * Обработчик изменения какого либо типа объекта
   */
  const onChangeObjectTypeChange = useCallback(
    (option: IDictionarySubjectTypeSelectOption) => {
      if (option && option?.value?.dictVersionId) {
        if (knoSupervisionUuid && (reasonUuid || orderVersionId)) {
          dispatch(
            dictionariesSubjectKindsItemGet(
              knoSupervisionUuid,
              reasonUuid,
              orderVersionId,
              option?.value?.dictVersionId,
            ),
          );
          dispatch(
            dictionariesSubjectSubKindsItemGet(
              knoSupervisionUuid,
              reasonUuid,
              orderVersionId,
              option?.value?.dictVersionId,
            ),
          );
        }
      }
    },
    [formRef, dispatch, knoSupervisionUuid, orderVersionId, reasonUuid],
  );

  const validRiskCategoryIds = useMemo(() => {
    if (!Array.isArray(riskCategoriesSelectOptions)) return new Set();

    return new Set(riskCategoriesSelectOptions.map(opt => opt.id));
  }, [riskCategoriesSelectOptions]);

  useEffect(() => {
    if (!isKnmPlanStatusConsidered || !isKnmKindRemarkExist || !formRef?.current) {
      return;
    }

    const objectsErknm = formRef?.current.getFieldState('objectsErknm')?.value;

    if (!Array.isArray(objectsErknm) || objectsErknm.length === 0 || validRiskCategoryIds.size === 0) {
      return;
    }

    const filtered = objectsErknm.filter(obj => {
      const typeId = obj?.riskCategory?.id ?? obj?.riskCategory?.value?.dictId;

      return typeId && validRiskCategoryIds.has(typeId);
    });

    if (filtered.length !== objectsErknm.length) {
      formRef.current.change('objectsErknm' as keyof IKnmErknmForm, filtered);
      formRef.current.change(`organizations` as keyof IKnmErknmForm);
    }
  }, [validRiskCategoryIds, formRef, isKnmPlanStatusConsidered, isKnmKindRemarkExist]);

  const isImpossibilityOfPrevious =
    reasonsErknm?.[0]?.reason?.type?.name === KnmReasonTypeNameEnum.IMPOSSIBILITY_OF_PREVIOUS;
  const isPrescriptionCheck = reasonsErknm?.[0]?.reason?.type?.name === KnmReasonTypeNameEnum.PRESCRIPTION_CHECK;

  const isFilledFromPrescriptionLink =
    reasonsErknm?.[0]?.reason?.type?.name === KnmReasonTypeNameEnum.PRESCRIPTION_CHECK &&
    isPassportByCheckPrescriptionOldRules === false;

  return (
    <FieldBlock
      label={
        <>
          Сведения об объектах контроля
          <ErknmFieldMark fieldName="objectsErknm" />
        </>
      }
      color="black"
      labelFontSize="medium"
      id={KNM_OBJECTS_INFO}
      labelId={OBJECTS_BLOCK_ID}
      button={
        !isImpossibilityOfPrevious &&
        !isFilledFromPrescriptionLink && (
          <>
            <Button
              className="shared-btn-add"
              text="Добавить объект из ЕРВК"
              type="button"
              variant="link"
              color="primary"
              id="erknmObjectsAddButton"
              disabled={isWatchOnly}
              onClick={openModal}
            />
            {!isPlanned &&
              (!lowRisk && isUseOnlyLowRiskInManualObject ? (
                <Tooltip
                  placement="top"
                  type="info"
                  content={
                    <div className="shared-tooltip-info-content" style={{ width: '450px' }}>
                      Для выбранного вида контроля недоступны объекты с низкой категорией риска, которые добавляются
                      вручную
                    </div>
                  }
                >
                  <Button
                    className="shared-btn-add"
                    text="Добавить вручную"
                    type="button"
                    variant="link"
                    color="primary"
                    id="erknmObjectsAddButton"
                    disabled={isDisabledButtonAddManual}
                    onClick={addKnmObject}
                  />
                </Tooltip>
              ) : (
                <Button
                  className="shared-btn-add"
                  text="Добавить вручную"
                  type="button"
                  variant="link"
                  color="primary"
                  id="erknmObjectsAddButton"
                  disabled={isDisabledButtonAddManual}
                  onClick={addKnmObject}
                />
              ))}
            <ErknmApproveRemarkAddButton sectionCode={ErknmApproveRemarkSectionCodeEnum.OBJECTS} />
          </>
        )
      }
      fillInProcess={<ErknmFillInProcessMessage name="objectsErknm" />}
    >
      {isPrescriptionCheck && <SelectPrescriptionNotice />}
      <ErknmApproveRemark sectionCode={ErknmApproveRemarkSectionCodeEnum.OBJECTS} />
      <KnmErvkObjectsModal
        watchOnly={isWatchOnly}
        dangerClassesSelectOptions={hazardClassApplies ? dangerClassesSelectOptions : undefined}
        riskCategoriesSelectOptions={!hazardClassApplies ? riskCategoriesSelectOptions : undefined}
        onClose={closeModal}
        visible={isModalVisible}
        onSubmit={addFromErvk}
        kindKnmCode={kindKnmCode}
      />

      {!!toDisplayFieldError && <p className="shared-input-error shared-row__small-margin">{toDisplayFieldError}</p>}

      <FieldArray name="objectsErknm">
        {({ fields }: FieldArrayRenderProps<IKnmErknmFormObject, HTMLElement>) => {
          const { visibleItems, hasMore, showMore, totalCount, visibleCount, isRendering } = useShowMore(fields.value, {
            initialCount: 10,
            incrementCount: 10,
          });

          if (!fields.length) {
            return null;
          }

          return (
            <>
              <Row>
                {visibleItems.map((fieldValue: IKnmErknmFormObject) => {
                  const index =
                    fields.value?.findIndex((item: IKnmErknmFormObject) => item.listId === fieldValue.listId) ?? 0;
                  const name = `objectsErknm[${index}]`;
                  const id = getObjectBlockId(fieldValue.listId);
                  const isErvkObject = !!fieldValue.ervkId;
                  const isItemWatchOnly = isWatchOnly || (isErvkObject && isChangeSubjectTypeFromActionsAvailable);

                  return (
                    <Row key={id} margin="medium" isListItem>
                      <KnmObjectItem
                        id={id}
                        index={index}
                        created={created}
                        formRef={formRef}
                        hazardClassApplies={hazardClassApplies}
                        name={name}
                        value={fieldValue}
                        objectTypesSelectOptions={objectTypesSelectOptions}
                        objectKindsSelectOptions={objectKindsSelectOptions}
                        objectSubKindsSelectOptions={objectSubKindsSelectOptions}
                        riskCategoriesSelectOptions={riskCategoriesSelectOptions}
                        dangerClassesSelectOptions={dangerClassesSelectOptions}
                        isImpossibilityOfPrevious={isImpossibilityOfPrevious}
                        isWatchOnly={isItemWatchOnly}
                        isCanRefreshControlObject={isCanRefreshControlObject}
                        objectKindChangeCallback={onChangeObjectKindChange}
                        objectTypeChangeCallback={onChangeObjectTypeChange}
                        objectKindSelectOptionsSelectorFunction={getKnmErknmSubjectKindsSelectOptions}
                        objectSubKindSelectOptionsSelectorFunction={getKnmErknmSubjectSubKindsSelectOptions}
                        onRemove={makeRemoveKnmObjectHandler(index, fieldValue.organizationErvkId)}
                        isErknm={true}
                        isPm={false}
                        addOnlyProductionObject={addOnlyProductionObject}
                        invalidFields={invalidFields}
                        isFilledFromPrescriptionLink={isFilledFromPrescriptionLink}
                      />
                    </Row>
                  );
                })}
              </Row>
              {isRendering && <Spinner className={styles.Loader} />}
              {hasMore && !isRendering && (
                <ShowMoreButton onClick={showMore} totalCount={totalCount} visibleCount={visibleCount} />
              )}
            </>
          );
        }}
      </FieldArray>
      {isImpossibilityOfPrevious && isObjectDeleted && (
        <div className={styles.Yellow}>
          Для добавления сведений в раздел необходимо удалить и повторно добавить ссылку на паспорт
        </div>
      )}
    </FieldBlock>
  );
};

const mapStateToProps = (state: IRootState): IErknmObjectsStoreProps => ({
  created: getKnmDataCreated(state),
  dangerClassesSelectOptions: getKnmErknmDangerClassesSelectOptions(state),
  formRef: getKnmFormRef(state),
  hazardClassApplies: getKnoSupervisionHazardClassApplies(state),
  knmType: getKnmTypeFormValue(state),
  objectKindsSelectOptions: getKnmErknmSubjectKindsSelectOptions(state),
  objectSubKindsSelectOptions: getKnmErknmSubjectSubKindsSelectOptions(state),
  objectTypesSelectOptions: getKnmErknmSubjectTypesSelectOptions(state),
  riskCategoriesSelectOptions: getKnmErknmRiskCategoriesSelectOptions(state),
  subjectTypeOptions: getTargetEntitySelectOptions(state),
  countriesSelectOptions: getCountriesSelectOptions(state),
  isCanRefreshControlObject: getKnmIsCanRefreshControlObject(state),
  settings: getAdminFetchSettings(state),
  isChangeSubjectTypeFromActionsAvailable: getKnmIsChangeSubjectTypeFromActionsAvailable(state),
  knmPlanStatus: getPlanListPlanErknmStatus(state),
  districtSelectOptions: getDistrictSelectOptions(state),
  knoSupervisionUuid: getKnmKnoSupervisionUuid(state),
  orderVersionId: getKnmOrderVersionId(state),
  reasonUuid: getKnmErknmReasonsFormValue(state)
    ?.map(x => x?.ervkUuid)
    ?.find(uuid => uuid),
  isPassportByCheckPrescriptionOldRules: getKnmErknmIsPrescriptionOldRules(state),
});

export const ErknmObjects = connect(mapStateToProps)(ErknmObjectsWithoutStore);
